import previewImg from './previewImg.vue';
export default previewImg;
